import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { TextStyles } from "@ingka/typography-shared";
import styles from "./TitledHeadingText.module.css";

type HeadingSize = "h1" | "h2" | "h3" | "h4";

const headingTextStyleMap: Record<HeadingSize, TextStyles> = {
  h1: "Heading.XL",
  h2: "Heading.L",
  h3: "Heading.M",
  h4: "Heading.S",
};

type TitledHeadingTextProps = {
  label: string;
  text: string;
  headingSize?: HeadingSize;
};

function TitledHeadingText({
  label,
  text,
  headingSize = "h2",
}: TitledHeadingTextProps) {
  return (
    <div className={styles["root"]}>
      <FixaText textStyle="Body.M" className={styles["label"]}>
        {label}
      </FixaText>
      <FixaText
        textStyle={headingTextStyleMap[headingSize]}
        tagName={headingSize}
      >
        {text}
      </FixaText>
    </div>
  );
}

export default TitledHeadingText;
